import React, { useState } from "react";
import { useBilling } from "../store/BillingContext";
import { blankDocument } from "../lib/utils";

export const ClientsView: React.FC = () => {
  const { state, setActiveForm, deleteClient, setActiveDoc } = useBilling();
  const [searchTerm, setSearchTerm] = useState("");

  const filteredClients = state.clients.filter((c) => {
    const q = searchTerm.toLowerCase();
    return (
      (c.company || "").toLowerCase().includes(q) ||
      (c.name || "").toLowerCase().includes(q) ||
      (c.email || "").toLowerCase().includes(q) ||
      (c.phone || "").toLowerCase().includes(q) ||
      (c.industry || "").toLowerCase().includes(q)
    );
  });

  const createInvoiceForClient = (clientId: string) => {
    const client = state.clients.find((c) => c.id === clientId);
    const newDoc = blankDocument("invoice", state);
    if (client) {
      newDoc.clientId = client.id;
      newDoc.company = client.company || client.name;
      newDoc.email = client.email;
      newDoc.phone = client.phone;
      newDoc.address = client.address;
      newDoc.clientGstin = client.gstin;
    }
    setActiveDoc(newDoc);
  };

  return (
    <section className="panel">
      <div className="panel-title" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h3>Customer Directory ({state.clients.length})</h3>
        <button
          className="primary"
          onClick={() =>
            setActiveForm({
              kind: "client",
              value: { id: "", name: "", company: "", email: "", phone: "", address: "", gstin: "", industry: "" },
            })
          }
        >
          <i className="fa-solid fa-user-plus" /> + Add New Client
        </button>
      </div>

      <div className="toolbar" style={{ margin: "14px 0" }}>
        <input
          type="text"
          placeholder="Search by company name, contact, email or phone..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ maxWidth: "400px" }}
        />
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))", gap: "16px", marginTop: "12px" }}>
        {filteredClients.length > 0 ? (
          filteredClients.map((c) => {
            const initials = (c.company || c.name || "CL").slice(0, 2).toUpperCase();
            const clientInvoices = state.invoices.filter((i) => i.clientId === c.id || i.company === c.company);

            return (
              <div
                key={c.id}
                style={{
                  background: "#ffffff",
                  border: "1px solid #e2e8f0",
                  borderRadius: "12px",
                  padding: "18px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.03)",
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
                  <div
                    style={{
                      width: "48px",
                      height: "48px",
                      borderRadius: "50%",
                      background: "#173b60",
                      color: "#ffffff",
                      display: "grid",
                      placeItems: "center",
                      fontWeight: 700,
                      fontSize: "16px",
                      flexShrink: 0,
                    }}
                  >
                    {initials}
                  </div>
                  <div style={{ overflow: "hidden" }}>
                    <div style={{ fontWeight: 700, fontSize: "16px", color: "#0f172a" }}>
                      {c.company || c.name}
                    </div>
                    {c.company && c.name && (
                      <div style={{ fontSize: "12px", color: "#64748b" }}>Contact: {c.name}</div>
                    )}
                    {c.industry && (
                      <span
                        style={{
                          fontSize: "10px",
                          background: "#f1f5f9",
                          padding: "2px 8px",
                          borderRadius: "10px",
                          color: "#475569",
                          fontWeight: 600,
                          display: "inline-block",
                          marginTop: "4px",
                        }}
                      >
                        {c.industry}
                      </span>
                    )}
                  </div>
                </div>

                <div style={{ fontSize: "12px", color: "#475569", lineHeight: 1.6, borderTop: "1px solid #f1f5f9", paddingTop: "10px" }}>
                  {c.email && <div><i className="fa-solid fa-envelope" style={{ width: "18px", color: "#94a3b8" }} /> {c.email}</div>}
                  {c.phone && <div><i className="fa-solid fa-phone" style={{ width: "18px", color: "#94a3b8" }} /> {c.phone}</div>}
                  {c.gstin && <div><i className="fa-solid fa-receipt" style={{ width: "18px", color: "#94a3b8" }} /> GSTIN: {c.gstin}</div>}
                  {c.address && (
                    <div style={{ marginTop: "4px", color: "#64748b", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                      <i className="fa-solid fa-location-dot" style={{ width: "18px", color: "#94a3b8" }} /> {c.address}
                    </div>
                  )}
                </div>

                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "auto", paddingTop: "12px", borderTop: "1px solid #f1f5f9" }}>
                  <span style={{ fontSize: "11px", color: "#64748b" }}>
                    {clientInvoices.length} {clientInvoices.length === 1 ? "invoice" : "invoices"}
                  </span>

                  <div style={{ display: "flex", gap: "6px" }}>
                    <button
                      onClick={() => createInvoiceForClient(c.id)}
                      style={{ fontSize: "11px", padding: "4px 8px", background: "#f8fafc" }}
                      title="Create Invoice for this client"
                    >
                      <i className="fa-solid fa-plus" /> Invoice
                    </button>
                    <button
                      onClick={() => setActiveForm({ kind: "client", value: c })}
                      style={{ fontSize: "11px", padding: "4px 8px" }}
                    >
                      Edit
                    </button>
                    <button
                      className="danger"
                      onClick={() => {
                        if (confirm(`Remove client ${c.company || c.name}?`)) {
                          deleteClient(c.id);
                        }
                      }}
                      style={{ fontSize: "11px", padding: "4px 8px" }}
                    >
                      <i className="fa-solid fa-trash" />
                    </button>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div style={{ gridColumn: "1/-1", textAlign: "center", padding: "40px", color: "#94a3b8" }}>
            No clients found matching "{searchTerm}".
          </div>
        )}
      </div>
    </section>
  );
};
